class Header {
  stateClasses = {
    hidden: 'header--hidden',
  }

  scrollUpThreshold = 100;

  constructor($el) {
    this.$el = $el;
    this.$window = $(window);
    this.lastScrollTop = 0;
    this.scrollUpDistance = 0;
    this.locked = false;
    this.init();
  }

  init = () => {
    this.$window.on("scroll", this.handleScroll);
    this.$window.on("header:lock", this.lock);
    this.$window.on("header:unlock", this.unlock);
  }

  lock = () => {
    this.locked = true;
    this.$el.addClass(this.stateClasses.hidden);
  }

  unlock = () => {
    this.locked = false;
  }

  handleScroll = () => {
    if (this.locked) return;

    const scrollTop = this.$window.scrollTop();
    const delta = scrollTop - this.lastScrollTop;
    const scrollingDown = delta > 0;

    if (scrollingDown) {
      this.scrollUpDistance = 0;
      this.$el.addClass(this.stateClasses.hidden);
    } else {
      this.scrollUpDistance += Math.abs(delta);

      if (this.scrollUpDistance >= this.scrollUpThreshold) {
        this.$el.removeClass(this.stateClasses.hidden);
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}

export default Header;